import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { pageIndex: Number }
  static targets = [
    'page',
    'nextButton',
    'backButton',
    'dotIndicator',
    'pageTop'
  ]

  initialize () {
    if (this.hasPageTarget) {
      // Start at the last page (most recent data)
      const lastPageIndex = this.pageTargets.length - 1
      this.pageIndexValue = lastPageIndex
      this.showPage(lastPageIndex)
    }
  }

  // Next (right arrow) goes to newer data (higher page index)
  // Disabled when at the last page (most recent)
  next (event) {
    this.scrollIntoView(this.pageTopTarget)
    this.pageIndexValue++
    this.hidePage(this.pageIndexValue - 1)
    this.showPage(this.pageIndexValue)
    this.makeInactive(this.dotIndicatorTargets[this.pageIndexValue - 1])
    this.makeActive(this.dotIndicatorTargets[this.pageIndexValue])

    // Enable back button (can go to older data)
    if (this.backButtonTarget.classList.contains('disabled-page-button')) {
      this.enableButton(this.backButtonTarget)
    }
    // Disable next button when at last page (most recent)
    if (this.pageIndexValue + 1 == this.pageTargets.length) {
      this.disableButton(this.nextButtonTarget)
    }
  }

  // Previous (left arrow) goes to older data (lower page index)
  // Disabled when at page 0 (oldest)
  previous (event) {
    this.scrollIntoView(this.pageTopTarget)
    this.pageIndexValue--
    this.hidePage(this.pageIndexValue + 1)
    this.showPage(this.pageIndexValue)
    this.makeInactive(this.dotIndicatorTargets[this.pageIndexValue + 1])
    this.makeActive(this.dotIndicatorTargets[this.pageIndexValue])

    // Enable next button (can go to newer data)
    if (this.nextButtonTarget.classList.contains('disabled-page-button')) {
      this.enableButton(this.nextButtonTarget)
    }
    // Disable back button when at page 0 (oldest)
    if (this.pageIndexValue == 0) {
      this.disableButton(this.backButtonTarget)
    }
  }

  hidePage (index) {
    this.pageTargets[index].classList.add('hidden')
  }

  showPage (index) {
    this.pageTargets[index].classList.remove('hidden')
  }

  makeActive (target) {
    target.classList.remove('bg-gray-1')
    target.classList.add('bg-violet')
  }

  makeInactive (target) {
    target.classList.add('bg-gray-1')
    target.classList.remove('bg-violet')
  }

  disableButton (target) {
    target.classList.add('disabled-page-button')
  }

  enableButton (target) {
    target.classList.remove('disabled-page-button')
  }

  scrollIntoView (target) {
    let currentHeaderPosition = window.getComputedStyle(document.querySelector('#TopMenu')).position
    if (currentHeaderPosition == 'fixed') {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
